import Grid from '@mui/material/GridLegacy';
import React from 'react';
import { Tile } from '../Tile';
import type { TilesCollectionProps } from './TilesCollection.types';

export const TilesCollectionComponent: React.FC<TilesCollectionProps> = ({
  model,
}) => {
  return (
    <Grid container spacing={5}>
      {model?.tiles?.map(
        (tile) => tile && <Tile tile={tile} key={tile.documentId} />
      )}
    </Grid>
  );
};
